'<template>
   <div class="page_dingyue_container" v-loading="loading">
      <!--入会申请-->
      <el-form :model="dingyue" ref="dingyue" class="zazhidingyue_formbox" :rules="ruhuiRules">
         <el-row :gutter="10">
            <el-col :span="12">
               <el-form-item label="收刊单位名称：" prop="youjiDanwei">
                  <el-input v-model="dingyue.youjiDanwei"></el-input>
               </el-form-item>
            </el-col>
            <el-col :span="12">
               <el-form-item label="收刊联系人：" prop="youjiLianxiren">
                  <el-input v-model="dingyue.youjiLianxiren"></el-input>
               </el-form-item>
            </el-col>
         </el-row>


         <el-row :gutter="10">
            <el-col :span="12">
               <el-form-item label="手机：" prop="youjiPhone">
                  <el-input v-model="dingyue.youjiPhone" maxlength="11"></el-input>
               </el-form-item>

            </el-col>
            <el-col :span="12">
               <el-form-item label="固定电话：">
                  <el-input v-model="dingyue.youjiTel"></el-input>
               </el-form-item>
            </el-col>
         </el-row>
         <el-row :gutter="10">
            <el-col :span="12">
               <el-form-item label="收刊详细地址：" prop="youjiDizhi">
                  <el-input v-model="dingyue.youjiDizhi"></el-input>
               </el-form-item>
            </el-col>
            <el-col :span="12">
               <el-form-item label="邮编：">
                  <el-input v-model="dingyue.youbian"></el-input>
               </el-form-item>
            </el-col>
         </el-row>
         <el-form-item label="发票类型：">
            <el-radio-group v-model="dingyue.fapiaoType">
               <el-radio label="1">增值税普通电子发票</el-radio>
               <el-radio label="2">增值税专用纸质发票</el-radio>
            </el-radio-group>
         </el-form-item>
         <el-row :gutter="10">
            <el-col :span="12">
               <el-form-item label="开票单位名称：" prop="fapiaoDanwei">
                  <el-input v-model="dingyue.fapiaoDanwei"></el-input>
               </el-form-item>
            </el-col>
            <el-col :span="12">
               <el-form-item label="单位纳税人识别号：" prop="fapiaoShuihao">
                  <el-input v-model="dingyue.fapiaoShuihao"></el-input>
               </el-form-item>
            </el-col>
         </el-row>
         <el-row :gutter="10" v-if="dingyue.fapiaoType == 1">
            <el-col :span="12">
               <el-form-item label="开票电话：">
                  <el-input v-model="dingyue.fapiaoTel"></el-input>
               </el-form-item>

            </el-col>
            <el-col :span="12">
               <el-form-item label="开票地址：">
                  <el-input v-model="dingyue.fapiaoDizhi"></el-input>
               </el-form-item>

            </el-col>
         </el-row>
         <el-row :gutter="10" v-else>
            <el-col :span="12">
               <el-form-item label="开票电话：" prop="fapiaoTel">
                  <el-input v-model="dingyue.fapiaoTel"></el-input>
               </el-form-item>

            </el-col>
            <el-col :span="12">
               <el-form-item label="开票地址：" prop="fapiaoDizhi">
                  <el-input v-model="dingyue.fapiaoDizhi"></el-input>
               </el-form-item>

            </el-col>
         </el-row>
         <el-row :gutter="10">
            <el-col :span="12">
               <el-form-item label="开户行及账号：" v-if="dingyue.fapiaoType == 1">
                  <el-input v-model="dingyue.fapiaoZhanghao"></el-input>
               </el-form-item>
               <el-form-item label="开户行及账号：" prop="fapiaoZhanghao" v-else>
                  <el-input v-model="dingyue.fapiaoZhanghao"></el-input>
               </el-form-item>
            </el-col>
            <el-col :span="12">
               <el-form-item label="接收发票电子邮箱：" prop="fapiaoEmail">
                  <el-input v-model="dingyue.fapiaoEmail"></el-input>
               </el-form-item>
            </el-col>
         </el-row>
         <el-row :gutter="10">

            <el-col :span="12">
               <el-form-item label="汇款账号：" prop="dingyueZhanghao">
                  <el-input v-model="dingyue.dingyueZhanghao" autocomplete="off"></el-input>
               </el-form-item>
            </el-col>
            <el-col :span="12">

               <el-form-item label="汇款名称：" prop="dingyueName">
                  <el-input v-model="dingyue.dingyueName" autocomplete="off"></el-input>
               </el-form-item>

            </el-col>
         </el-row>
         <el-row :gutter="10">
            <el-col :span="12">
               <el-form-item label="订阅数量：" prop="dingyueNum">
                  <el-input-number v-model="dingyue.dingyueNum" :min="1" :max="100" @change="changeDingyueNum">
                  </el-input-number>
               </el-form-item>
            </el-col>
            <!-- <el-form-item label="汇款时间：" prop="dingyueHuikuanTime">
                  <el-date-picker v-model="dingyue.dingyueHuikuanTime" align="right" type="date" placeholder="选择时间" :picker-options="pickerOptions">
                  </el-date-picker>
               </el-form-item> -->
            <el-col :span="12">
               <el-form-item label="总金额：" prop="zongjinePrice">
                  <el-input v-model="dingyue.zongjinePrice" autocomplete="off"></el-input>
               </el-form-item>
            </el-col>
         </el-row>
         <!-- <el-row :gutter="10">
            <el-col :span="12">
               <el-form-item label="总金额：" prop="zongjinePrice">
                  <el-input v-model="dingyue.zongjinePrice" autocomplete="off"></el-input>
               </el-form-item>
            </el-col>
            <el-col :span="12">
               <el-form-item label="总金额（大写）：" prop="zongjine">
                  <el-input v-model="dingyue.zongjine" autocomplete="off" readonly></el-input>
               </el-form-item>
            </el-col>
         </el-row> -->
         <el-form-item label="其他信息：" prop="beizhu">
            <el-input type="textarea" :rows="2" v-model="dingyue.beizhu" autocomplete="off"></el-input>
         </el-form-item>

         <el-form-item>
            <el-button type="primary" class="tijiao_btns" @click="submitForm('dingyue')">确 定</el-button>
         </el-form-item>
      </el-form>
   </div>
</template>


<script>
   import "@/assets/css/index2.less"
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   export default {
      name: 'dingyue_page',
      components: {

      },

      data() {
         const validatePhone = (rule, value, callback) => {
            // console.log(rule)
            // console.log(value)
            // console.log(callback)

            // 判断输入框中是否输入手机号
            if (!value) {
               callback(new Error('手机号不能为空'))
            }
            //正则表达式进行验证手机号，从1开始，第二位是35789中的任意一位，以9数字结尾
            if (!/^1\d{10}$/.test(value)) {
               callback(new Error('手机号格式不正确'))
            }
            callback()
         }
         return {
            loading: false,

            listStatus: true,
            zazhi_list: [],
            pageNum: 1,
            pageSize: 10,
            pagecount: 10,

            zazhiStatus: false, //入会弹框

            pickerOptions: {
               disabledDate(time) {
                  return time.getTime() > Date.now();
               },
               shortcuts: [{
                  text: '今天',
                  onClick(picker) {
                     picker.$emit('pick', new Date());
                  }
               }, {
                  text: '昨天',
                  onClick(picker) {
                     const date = new Date();
                     date.setTime(date.getTime() - 3600 * 1000 * 24);
                     picker.$emit('pick', date);
                  }
               }, {
                  text: '一周前',
                  onClick(picker) {
                     const date = new Date();
                     date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                     picker.$emit('pick', date);
                  }
               }]
            },
            dingyue: {
               youjiZazhiCode: "", //杂志code
               youjiDanwei: '',
               /** 收刊单位名称 */
               youjiLianxiren: '',
               /** 收刊联系人 */
               youjiPhone: '',
               /** 手机 */
               youjiTel: '',
               /** 固定电话 */
               youjiDizhi: '',
               /** 收刊详细地址 */
               youbian: '',
               /** 邮编 */

               fapiaoType: '1', //1普通 2增值
               fapiaoZengzhi: '',
               /** 增值税普通电子发票YN */
               fapiaoZhi: '',
               /** 增值税专用纸质发票YN */
               fapiaoDanwei: '',
               /** 开票单位名称 */
               fapiaoDizhi: '',
               /** 开票地址 */
               fapiaoTel: '',
               /** 开票电话 */
               fapiaoShuihao: '',
               /** 单位纳税人识别号 */
               fapiaoZhanghao: '',
               /** 开户行及账号 */
               fapiaoEmail: '',
               /** 接收发票电子邮箱 */

               dingyueNum: '',
               /** 订阅数量 */
               zongjine: '',
               /** 总金额（大写） */
               zongjinePrice: '234',
               /** 总金额 */
               dingyueZhanghao: '',
               /** 汇款账号 */
               dingyueName: '',
               /** 汇款名称 */
               // dingyueFukuan: 'N',
               /** 是否已付款YN */

               dingyueHuikuanTime: '',
               /** 订阅汇款时间 */
               status: 'N',
               /** 处理状态YN */
               beizhu: '',
               /** 备注 */
               userId: '',
               /** 用户ID，如果登录存上 */
            },
            ruhuiRules: {
               youjiDanwei: [{
                  required: true,
                  message: '请输入收刊单位名称',
                  trigger: 'blur'
               }, ],
               youjiLianxiren: [{
                  required: true,
                  message: '请输入 收刊联系人',
                  trigger: 'blur'
               }, ],
               youbian: [{
                  required: true,
                  message: '请输入邮编',
                  trigger: 'blur'
               }, ],
               youjiPhone: [{
                     required: true,
                     message: '请输入手机号',
                     trigger: 'blur'
                  },
                  {
                     required: true,
                     trigger: 'blur',
                     validator: validatePhone
                  }
               ],
               youjiTel: [{
                  required: true,
                  message: '请输入固定电话',
                  trigger: 'blur'
               }, ],
               youjiDizhi: [{
                  required: true,
                  message: '请输入收刊详细地址',
                  trigger: 'blur'
               }, ],

               fapiaoDanwei: [{
                  required: true,
                  message: '请输入开票单位名称',
                  trigger: 'blur'
               }, ],
               fapiaoDizhi: [{
                  required: true,
                  message: '请输入开票地址',
                  trigger: 'blur'
               }, ],
               fapiaoTel: [{
                  required: true,
                  message: '请输入开票电话',
                  trigger: 'blur'
               }, ],
               fapiaoShuihao: [{
                  required: true,
                  message: '请输入单位纳税人识别号',
                  trigger: 'blur'
               }, ],
               fapiaoZhanghao: [{
                  required: true,
                  message: '请输入开户行及账号',
                  trigger: 'blur'
               }, ],
               fapiaoEmail: [{
                  required: true,
                  message: '请输入接收发票电子邮箱',
                  trigger: 'blur'
               }, ],
               dingyueNum: [{
                  required: true,
                  message: '请输入订阅数量',
                  trigger: 'blur'
               }, ],
               zongjine: [{
                  required: true,
                  message: '请输入总金额（大写）',
                  trigger: 'blur'
               }, ],
               zongjinePrice: [{
                  required: true,
                  message: '请输入总金额',
                  trigger: 'blur'
               }, ],
               dingyueZhanghao: [{
                  required: true,
                  message: '请输入汇款账号',
                  trigger: 'blur'
               }, ],
               dingyueName: [{
                  required: true,
                  message: '请输入汇款名称',
                  trigger: 'blur'
               }, ],
               dingyueHuikuanTime: [{
                  required: true,
                  message: '请选择汇款时间',
                  trigger: 'change'
               }, ],
               status: [{
                  required: true,
                  message: '请选择汇款状态',
                  trigger: 'change'
               }, ],
            },
            fileNum: 1, //最多上传数量

         };
      },
      watch: {
         // 完整写法：
         'dingyue.zongjinePrice': {
            deep: true, //deep对复杂数据，深度侦听（数量、数据内部变化都能侦听到！）不仅会监听地址的变化，还会监听对象内部属性的变化
            handler(newval, oldval) { //handler:操作，当数据变化时，执行那个函数！
               this.dingyue.zongjine = this.menoyToUppercase(newval);
            },
            immediate: true, //immediate:是否让上面的handler在组件加载完成后立马先执行一下？代表页面一加载，会先执行一次处理程序
         }
      },
      mounted() {
         if (this.$route.params.code) {
            this.dingyue.youjiZazhiCode = this.$route.params.code
         }
         this.getlist();
      },
      methods: {
         changeDingyueNum() {
            this.dingyue.zongjinePrice = this.dingyue.dingyueNum * 234
         },

         getlist() {
            var _this = this;
            _this.$api.zazhiList({
               pageNum: _this.pageNum,
               pageSize: _this.pageSize
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.zazhi_list = res.data.list;
                  _this.pagecount = res.data.total;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function (error) {
               _this.$message.error(error.msg);
            });
         },

         openZazhiDingyue(code) {
            this.dingyue.youjiZazhiCode = code;
            this.zazhiStatus = true;
         },


         //提交申请
         submitForm(formName) {
            var _this = this;
            this.$refs[formName].validate((valid) => {
               if (valid) {
                  const loading = this.$loading({
                     lock: true,
                     text: '提交中...',
                     spinner: 'el-icon-loading',
                  });
                  if (_this.dingyue.fapiaoType == '1') {
                     _this.dingyue.fapiaoZengzhi = 'Y';
                     _this.dingyue.fapiaoZhi = 'N';
                  } else {
                     _this.dingyue.fapiaoZengzhi = 'N';
                     _this.dingyue.fapiaoZhi = 'Y';
                  }
                  _this.$api.zazhiDingyue(_this.dingyue).then(res => {
                     loading.close();
                     if (res.code == 200) {
                        // _this.$message({
                        //    message: '订阅杂志成功，稍后会有工作人员联系您！',
                        //    type: 'success'
                        // });
                        // _this.zazhiStatus = false;
                        // _this.$refs[formName].resetFields()
                        this.$alert('订阅杂志成功，稍后会有工作人员联系您！', '提示', {
                           confirmButtonText: '确定',
                           callback: action => {
                              _this.zazhiStatus = false;
                              _this.$refs[formName].resetFields()
                           }
                        });
                     } else {
                        _this.$message.error(res.msg);
                     }
                  }).catch(function (error) {
                     loading.close();
                     _this.loading = false;
                     _this.$message.error(error.msg);
                  });
               } else {
                  console.log('error submit!!');
                  return false;
               }
            });
         },
         //分页
         handleCurrentChange(val) {
            this.loading = true;
            this.pageNum = val;
            this.getlist();
         },
         //关闭弹框
         closedialog() {
            this.$emit('closeruhui')
         },

         //转大写
         menoyToUppercase(money) {
            var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'); //汉字的数字
            var cnIntRadice = new Array('', '拾', '佰', '仟'); //基本单位
            var cnIntUnits = new Array('', '万', '亿', '兆'); //对应整数部分扩展单位
            var cnDecUnits = new Array('角', '分', '毫', '厘'); //对应小数部分单位
            var cnInteger = '整'; //整数金额时后面跟的字符
            var cnIntLast = '元'; //整数完以后的单位
            //最大处理的数字
            var maxNum = 999999999999999.9999;
            var integerNum; //金额整数部分
            var decimalNum; //金额小数部分
            //输出的中文金额字符串
            var chineseStr = '';
            var parts; //分离金额后用的数组，预定义
            if (money == '') {
               return '';
            }

            money = parseFloat(money);
            if (money >= maxNum) {
               //超出最大处理数字
               return '超出最大处理数字';
            }
            if (money == 0) {
               chineseStr = cnNums[0] + cnIntLast + cnInteger;
               return chineseStr;
            }
            //四舍五入保留两位小数,转换为字符串
            money = Math.round(money * 100).toString();
            integerNum = money.substr(0, money.length - 2);
            decimalNum = money.substr(money.length - 2);
            //获取整型部分转换
            if (parseInt(integerNum, 10) > 0) {
               var zeroCount = 0;
               var IntLen = integerNum.length;
               for (var i = 0; i < IntLen; i++) {
                  var n = integerNum.substr(i, 1);
                  var p = IntLen - i - 1;
                  var q = p / 4;
                  var m = p % 4;
                  if (n == '0') {
                     zeroCount++;
                  } else {
                     if (zeroCount > 0) {
                        chineseStr += cnNums[0];
                     }
                     //归零
                     zeroCount = 0;
                     chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                  }
                  if (m == 0 && zeroCount < 4) {
                     chineseStr += cnIntUnits[q];
                  }
               }
               chineseStr += cnIntLast;
            }
            //小数部分
            if (decimalNum != '') {
               var decLen = decimalNum.length;
               for (var i = 0; i < decLen; i++) {
                  var n = decimalNum.substr(i, 1);
                  if (n != '0') {
                     chineseStr += cnNums[Number(n)] + cnDecUnits[i];
                  }
               }
            }
            if (chineseStr == '') {
               chineseStr += cnNums[0] + cnIntLast + cnInteger;
            } else if (decimalNum == '' || /^0*$/.test(decimalNum)) {
               chineseStr += cnInteger;
            }
            return chineseStr;
         }
      }
   }
</script>
<style lang="less">
   .zazhidingyue_formbox {
      padding: 0 50px;

      label {
         width: 180px;
      }

      .imgupload {
         .el-upload {
            width: 100px;
            height: 100px;
            line-height: 100px;
            border: 1px dashed #e9e9e9;
            position: relative;

            i {
               font-size: 20px;
               color: #999;
            }

            p {
               line-height: 40px;
               position: absolute;
               bottom: 0px;
               left: 0px;
               width: 100%;
               text-align: center;
               font-size: 12px;
               color: #999;
            }
         }
      }

      .el-input,
      .el-textarea,
      .el-input-number {
         width: 300px;

         textarea {
            resize: none;
         }
      }

      .down_box {
         a {
            color: #409EFF;
         }
      }
   }
</style>